import { addRule } from '@chrisjwarnes/form-validator/src'

export default function () {
  addRule('valRecaptcha', function (field) {
    return {
      type: 'string',
      asyncValidator: (rule, value) => {
        return new Promise((resolve, reject) => {
          console.log('get token')
          if (!window.grecaptcha) {
            reject(new Error('grecaptcha script is missing.'))
          }
          window.grecaptcha.execute(field.dataset.valRecaptchaKey, { action: field.dataset.valRecaptchaAction }).then(function (token) {
            field.value = token
            resolve()
          })
        })
      },
      message: field.dataset.valRecaptcha
    }
  }, true)
}
